var chunkMapping = {
	"151": [
		3937
	],
	"182": [
		7225
	],
	"197": [
		7125
	],
	"203": [
		9549
	],
	"234": [
		6177
	],
	"297": [
		1877
	],
	"447": [
		5869
	],
	"519": [
		4829
	],
	"681": [
		4003
	],
	"689": [
		1300
	],
	"793": [
		4425
	],
	"862": [
		6357
	],
	"901": [
		5885
	]
};
var idToExternalAndNameMapping = {
	"1300": [
		"default",
		"./ReturnApp",
		4311
	],
	"1877": [
		"default",
		"./DropOffApp",
		9748
	],
	"3937": [
		"default",
		"./PlacementApp",
		2016
	],
	"4003": [
		"default",
		"./GameApp",
		3274
	],
	"4425": [
		"default",
		"./ReceivingDeviceApp",
		1977
	],
	"4829": [
		"default",
		"./LaundryApp",
		6532
	],
	"5869": [
		"default",
		"./ServiceMenuApp",
		751
	],
	"5885": [
		"default",
		"./StorageApp",
		2404
	],
	"6177": [
		"default",
		"./SwissPostC2CApp",
		5314
	],
	"6357": [
		"default",
		"./VendingApp",
		4644
	],
	"7125": [
		"default",
		"./CourierDeviceApp",
		5053
	],
	"7225": [
		"default",
		"./C2CApp",
		2928
	],
	"9549": [
		"default",
		"./ReceivingApp",
		8660
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}